/**
 * Implements a desktop wallet overview page
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import {
  IWalletOverview,
  IWalletTradesCountAndVolume,
} from '@kattana-io/common';
// import Graph from './Graph';
import Overview from './Overview';
import Tokens from './Tokens';
import Trades from './Trades';
import Watchlist from './Watchlist';
import { WalletAPI } from '../../store/createStore';
import Fallback from '../../components/Fallback';

import './styles.scss';

const WalletBody = () => {
  const params = useParams();

  const [wallet, setWallet] = useState<IWalletOverview | null>(null);
  const [tradesAndVolume, setTradesAndVolume] =
    useState<IWalletTradesCountAndVolume | null>(null);
  const [walletLoading, setWalletLoading] = useState(true);
  const [tradesAndVolumeLoading, setTradesAndVolumeLoading] = useState(true);

  const chain = params.chain;
  const address = params.address;

  useEffect(() => {
    const controller = new AbortController();

    if (chain && address) {
      setWalletLoading(true);
      setTradesAndVolumeLoading(true);
      WalletAPI.fetchWalletOverview(chain, address, controller).then((resp) => {
        setWallet(resp);
        setWalletLoading(false);
      });
      WalletAPI.fetchTradesCountAndVolume(chain, address, controller).then(
        (resp) => {
          setTradesAndVolume(resp);
          setTradesAndVolumeLoading(false);
        }
      );
    }

    return () => controller.abort();
  }, [chain, address]);

  return (
    <div className='wallet_page'>
      <div className='wallet_page__top_block'>
        <ErrorBoundary
          fallbackRender={(props) => (
            <Fallback
              {...props}
              className='watchlist'
              title='Wallets Watchlist'
            />
          )}
          onReset={(details) => {
            // Reset the state of your app so the error doesn't happen again
          }}
        >
          <Watchlist currentAddress={wallet?.wallet_address} chain={chain} />
        </ErrorBoundary>
        <div className='wallet_page__top_block__right_section'>
          <ErrorBoundary
            fallbackRender={(props) => (
              <Fallback
                {...props}
                className='overview'
                title='Wallet Overview'
              />
            )}
            onReset={(details) => {
              // Reset the state of your app so the error doesn't happen again
            }}
          >
            <Overview
              wallet={wallet}
              tradesAndVolume={tradesAndVolume}
              chain={chain}
              address={address}
              loading={walletLoading || tradesAndVolumeLoading}
            />
          </ErrorBoundary>
          <ErrorBoundary
            fallbackRender={(props) => (
              <Fallback {...props} className='tokens' title='Token List' />
            )}
            onReset={(details) => {
              // Reset the state of your app so the error doesn't happen again
            }}
          >
            <Tokens
              tokens={wallet?.tokens || []}
              loading={walletLoading}
              chain={chain}
            />
          </ErrorBoundary>
        </div>
      </div>
      <div className='wallet_page__bottom_block'>
        {/* <ErrorBoundary
          fallbackRender={(props) => (
            <Fallback {...props} className='graph' title='Wallet Chart' />
          )}
          onReset={(details) => {
            // Reset the state of your app so the error doesn't happen again
          }}
        >
          <Graph />
        </ErrorBoundary> */}
        <ErrorBoundary
          fallbackRender={(props) => (
            <Fallback {...props} className='trades' title='Wallet Trades' />
          )}
          onReset={(details) => {
            // Reset the state of your app so the error doesn't happen again
          }}
        >
          <Trades
            loading={tradesAndVolumeLoading}
            tradesCount={tradesAndVolume?.trades_count_total}
          />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default WalletBody;
